const SEGMENT_AVATARS = [
  '/images/avatar-presets/avatar_shawn.png',
  '/images/avatar-presets/avatar_ann.png',
  '/images/avatar-presets/avatar_dexter.png',
  '/images/avatar-presets/avatar_judy.png',
  '/images/avatar-presets/avatar_amina.png',
  '/images/avatar-presets/avatar_anthony.png',
  '/images/avatar-presets/avatar_rika.png',
  '/images/avatar-presets/avatar_anastasia.png',
  '/images/avatar-presets/avatar_marianne.png',
];

export function getSegmentAvatar(index: number): string {
  return SEGMENT_AVATARS[index % SEGMENT_AVATARS.length];
}
